import { createElement, Suspense } from "react";
const isComponent = component => {
  return typeof component === "function";
};
export const withSuspense = (WrappedComponent, defaultFallback, {
  ssr = true
} = {}) => {
  return function WithSuspense(props) {
    const fallback = props.fallback ?? (isComponent(defaultFallback) ? createElement(defaultFallback, props) : defaultFallback) ?? null;
    if (typeof window === "undefined" && !ssr) {
      return <>{fallback}</>;
    }
    return <Suspense fallback={fallback} key={props.suspenseKey}>
        <WrappedComponent {...props} />
      </Suspense>;
  };
};